<template>
  <div class="main" v-bind:class="{ active: showVideo }">
    <div class="container">
      <video class="intro" ref="vid" preload="none" controls="controls">
        <!--<source src="../../static/bg.mp4" type="video/mp4">-->
        <source src="https://s3-ap-southeast-2.amazonaws.com/siberianlarchwood/bg.mp4" type="video/mp4">
      </video>
    </div>
    <button class="svg-btn" @click="stop">
      <svg viewBox="0 0 24 24">
        <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
      </svg>
    </button>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        showVideo: false
      }
    },
    components: {
    },
    methods: {
      show: function () {
        this.showVideo = true
      },
      play: function () {
        this.$refs.vid.play()
      },
      stop: function () {
        this.$refs.vid.pause()
        this.$refs.vid.currentTime = 0
        this.showVideo = false
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .main {
    z-index: 10;
    width: 100vw;
    height: 100vh;
    background-color: #000;
    position: fixed;
    top: 0;
    left: 0;
    display: none;
  }
  .container {
    width: 100vw;
    height: 100vh;
  }
  .active {
    display: block;
  }
  .intro {
    width: 100%;
    height: 100%;
    margin: auto;
    /*background: #ebebeb url('../../static/img/preload.gif') no-repeat center center;*/
    background: url('../../static/img/preload.gif') no-repeat center center;
    background-size: auto;
  }
  svg {
    width: 24px;
    height: 24px;
    fill: #FFF;
  }
  .svg-btn {
    background: none;
    width: 45px;
    height: 45px;
    border: none;
    outline: none;
    cursor: pointer;
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 11;
  }
</style>



// WEBPACK FOOTER //
// IntroVideo.vue?b8c7a1c8